module.exports = __webpack_public_path__ + "static/media/Austin.d8f0b913.png";